import Vue from 'vue'

export default Vue.extend({
  methods: {
    dateObjectToString (date) {
      let year = date.getFullYear()
      let month = this.pad(date.getMonth() + 1)
      let day = this.pad(date.getDate())

      return year + '-' + month + '-' + day
    },

    createDateBasedDocNumber () {
      let date = new Date()
      let year = date.getFullYear().toString().substr(2, 2)
      let month = this.pad(date.getMonth() + 1)
      let day = this.pad(date.getDate())
      let hour = this.pad(date.getHours() + 1)
      let minute = this.pad(date.getMinutes())

      return year + month + day + hour + minute
    },

    pad (number) {
      return number < 10 ? '0' + number : number.toString()
    }
  }
})



// WEBPACK FOOTER //
// ./src/Mixins/SigmaClientNew/DateMixins.js